<template>
	<sf-data-table
		ref="dataTable"
		:pageUnit="pagingInfo.pageUnit"
		:totalSize="pagingInfo.totalSize"
		paging
		index
		:columns="columns"
		:rows="rows"
		fit="fit"
		:stripe="false"
		:selection="false"
		:excel="(isButton_(scrId, 'EX') && (flgPqyrgGrp || flgPqyrvGrp || flgPqyapGrp || flgPqypoGrp || flgPqyipGrp)) || flgOsGrp"
		:customExcel="excelFunc"
		@changedPage="changedPage"
	>
		<!-- <template v-slot:actionsLeft>
			<sf-button line icon="square-plue" :onClick="openPopup">
				{{ getMessage_('QWCC001083') }}
			</sf-button>
		</template> -->
	</sf-data-table>
</template>

<script>
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@pqy/pcku/PrtRpt/store/helpers';
import PartCku from '@pqy/pcku/PartCku/PartCku';
import utils from '@/utils';
import objectToQuerystring from '@/utils/sfaas_temp/objectToQueryString';
import { BASE_URL } from '@/constants';

export default {
	props: {
		scrId: { type: String, default: '' },
		flgOsGrp: { type: Boolean, default: false },
		flgPqyapGrp: { type: Boolean, default: false },
		flgPqyrvGrp: { type: Boolean, default: false },
		flgPqyrgGrp: { type: Boolean, default: false },
		flgPqycpGrp: { type: Boolean, default: false },
		flgPqypoGrp: { type: Boolean, default: false },
		flgHmcrdGrp: { type: Boolean, default: false },
		flgPqylpGrp: { type: Boolean, default: false },
		flgPqyipGrp: { type: Boolean, default: false}
	},
	async created() {
		await this.getCommCodesOnce_(); //공통코드 한번에 부르기
		// await this.getCommCodes_({ key: 'partClList', codeType: 'PART_CL' }); //유형;
		// await this.getCommCodes_({ key: 'ovrlJgmtCdList', codeType: 'OVRL_JGMT' }); //종합판정;
		// await this.getCommCodes_({ key: 'pgsStPcCdList', codeType: 'PGS_ST_PC' }); //부품검사 진행상태;

		// await this.getCommCodes_({ key: 'lugyCdList', codeType: 'LUGY' }); //긴급도
		// await this.getCommCodes_({ key: 'pgsStPcCdList', codeType: 'PGS_ST_PC' }); //진행상태;
		// await this.getCommCodes_({ key: 'badTypeLgrpCdList', codeType: 'BAD_TYPE_LGRP' }); //유형;
		// await this.getCommCodes_({ key: 'occuPlCdList', codeType: 'OCCU_PL' }); //발생장소;
		// await this.getCommCodes_({ key: 'rptpPrcsCdList', codeType: 'RPTP_PRCS' }); //고품처리;
		// await this.getCommCodes_({ key: 'mdvRplCdList', codeType: 'MDV_RPL' }); //대책회신;
		// await this.getCommCodes_({ key: 'partGCdList', codeType: 'PART_G' }); //소싱구분;
	},
	computed: {
		...rootComputed,
		...serviceComputed,
		rows() {
			return this.resultList;
		},
		columns() {
			return [
				{
					label: this.getMessage_('QWCC001034'), //ppr번호
					prop: 'pprNo',
					minWidth: '160px',
					sortable: true,
					highlight: true,
					clickEvent: this.clickPprNo
				},
				{
					label: this.getMessage_('QWCC001438'), //제목
					prop: 'badTitlSbc',
					minWidth: '100px',
					sortable: true
				},
				{
					label: this.getMessage_('QWCC001382'), //작성자
					prop: 'affrDspoNm1',
					minWidth: '100px',
					sortable: true
				},
				{
					label: this.getMessage_('QWCC001094'), //진행상태
					prop: 'pgsStCd',
					minWidth: '1px',
					sortable: true
				},
				{
					label: this.getMessage_('QWCC001094'), //진행상태
					prop: 'pgsStNm',
					minWidth: '79px',
					sortable: true
				},
				{
					label: this.getMessage_('QWCC000958'), //협력사
					prop: 'cofCd',
					minWidth: '1px',
					sortable: true
				},
				// {
				// 	label: this.getMessage_('QWCC001418'), //긴급도
				// 	prop: 'lugyCd',
				// 	minWidth: '80px',
				// 	sortable: true,
				// 	form: {
				// 		type: 'select',
				// 		options: this.getLugyCdList_,
				// 		isDisabled: ({}) => true // 에디트 방지
				// 	}
				// },
				{
					label: this.getMessage_('QWCC000958'), //협력사명
					prop: 'cofNm',
					minWidth: '99px',
					sortable: true
				},
				{
					label: this.getMessage_('QWCC000981'), //소싱구분
					prop: 'partGCd',
					minWidth: '80px',
					sortable: true,
					form: {
						type: 'select',
						options: this.getPartGCdList_,
						isDisabled: ({}) => true // 에디트 방지
					}
				},
				{
					label: this.getMessage_('QWCC000956'), //품번
					prop: 'partNo',
					minWidth: '100px',
					sortable: true
				},
				{
					label: this.getMessage_('QWCC000957'), //품명
					prop: 'partNm',
					minWidth: '100px',
					sortable: true
					// highlight: true,
					// clickEvent: this.clickPartNo
				},
				{
					label: this.getMessage_('QWCC001418'), //긴급도
					prop: 'lugyCd',
					minWidth: '80px',
					sortable: true,
					form: {
						type: 'select',
						options: this.getLugyCdList_,
						isDisabled: ({}) => true // 에디트 방지
					}
				},
				{
					label: this.getMessage_('QWCC000069'), //유형
					prop: 'badTypeLgrpCd',
					minWidth: '80px',
					sortable: true,
					form: {
						type: 'select',
						options: this.getBadTypeLgrpList_,
						isDisabled: ({}) => true // 에디트 방지
					}
				},

				{
					label: this.getMessage_('QWCC001419'), //라인정지 시간
					prop: 'lnStpTm',
					minWidth: '100px',
					sortable: true
				},
				{
					label: this.getMessage_('QWCC000074'), //불량수량
					prop: 'badQty',
					minWidth: '100px',
					sortable: true
				},
				{
					label: this.getMessage_('QWCC001954'), //고품수량(격리수량)
					prop: 'sprtQty',
					minWidth: '100px',
					sortable: true
				},
				{
					label: this.getMessage_('QWCC001455'), //고품처리
					prop: 'rptpPrcsCd',
					minWidth: '80px',
					sortable: true,
					form: {
						type: 'select',
						options: this.getRptpPrcsCdList_,
						isDisabled: ({}) => true // 에디트 방지
					}
				},
				{
					label: this.getMessage_('QWCC001436'), //대책 회신
					prop: 'mdvRplCd',
					minWidth: '100px',
					sortable: true,
					form: {
						type: 'select',
						options: this.getMdvRplCdList_,
						isDisabled: ({}) => true // 에디트 방지
					}
				},
				{
					label: this.getMessage_('QWCC001444'), //대책일자
					prop: 'mdvDd',
					minWidth: '99px',
					sortable: true
				},
				{
					label: this.getMessage_('QWCC001460'), //조치처
					prop: 'rcptNm',
					minWidth: '130px',
					sortable: true
				},
				{
					label: this.getMessage_('QWCC001032'), //발생일자
					prop: 'occuDd',
					minWidth: '1px',
					sortable: true
				},
				{
					label: this.getMessage_('QWCC002059'), //제기일
					prop: 'pprsDd',
					minWidth: '99px',
					sortable: true
				},
				{
					label: this.getMessage_('QWCC001420'), //회신요구일
					prop: 'rplRqDd',
					minWidth: '100px',
					sortable: true
				}
			];
		}
	},
	methods: {
		...rootMethods,
		...serviceMethods,
		...utils,
		async changedPage({ currentPageVal, pageUnitVal, prePage, prePageUnit }) {
			if (!prePage || !prePageUnit) {
				//초기값 셋팅시 이미 searchBar에서 데이터를 조회했기 때문에 중복 조회 하지않도록 처리
				return;
			}
			this.setPagingInfo_({ key: 'currentPage', value: currentPageVal });
			this.setPagingInfo_({ key: 'pageUnit', value: pageUnitVal });
			this.$emit('Refresh');
		},
		async clickPartNo(row) {
			const { partNo, ckuNo } = row;
			const name = this.getMessage_('QWCC000938');

			let item = {
				name,
				component: PartCku,
				scrId: this.partCkuScrId, //이동할 scrId
				msgKey: 'QWCC000938'
			};

			await this.getScreen_({ scrId: item.scrId });
			await this.$sf_removeTab(item.scrId);
			await this.$sf_addTab(item, item.scrId, { scrId: item.scrId, partNo, ckuNo });
		},
		openPopup() {
			this.$emit('openPopup');
		},
		clickPprNo(row) {
			try{
				if(this.flgPqypoGrp && row.pgsStCd!=='20' && row.pgsStCd!=='30'){
					throw new Error(this.getMessage_('QWCC002085'));
				}else{
					this.$emit('openPopup', row);
				}
			}catch(error){
				this.$sf_toast({ type: 'error', message: error.message || error });
			}
			
		},
		excelFunc() {
			//커스텀 엑셀다운로드시 필요한 함수
			let queryStr = '';

			queryStr = objectToQuerystring({
				pprNo: this.searchParams.pprNo,
				partNo: this.searchParams.partNo,
				partNm: this.searchParams.partNm,
				pgsStCd: this.searchParams.pgsStCd,
				ckuNo: this.searchParams.ckuNo,
				cofCd: this.searchParams.cofCd,
				cofNm: this.searchParams.cofNm,
				strDt: this.searchParams.strDt,
				endDt: this.searchParams.endDt,
				partGCd: this.searchParams.partGCd
			});

			const url = `${BASE_URL}/pqy/pcku/prtRpt/v1/rpts/excel` + queryStr;
			const params = { url, columns: this.getExcelColumns_ };

			this.xlsxDown(params).catch(error => {
				this.$sf_toast({ type: 'error', message: error.message });
			});
		}
	}
};
</script>

<style></style>
